module.exports = __webpack_public_path__ + "img/default-img-instructors.0425f28d.png";